export const T_PREFIX = 'products-fe.containers.application_review';
export const POLLING_INTERVAL = 5 * 1000;
export const SLOW_POLLING_INTERVAL = 30 * 1000;
